<template>
    <div class="homepage-body">
        <slot />
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.homepage-body {
    float: right;
    padding: 0 50px 30px;
    width: 100%;
    max-width: 700px;

    @media (max-width: $screen-page) {
        padding: 0 25px 30px;

        .typo--wrapped {
            padding: 0 15px;

            .typo-box {
                margin: 0 0;
            }
        }
    }

    @media (max-width: $screen-laptop) {
        float: none;
        margin: 0 auto;
        padding: 0 50px 50px;
    }

    @media (max-width: $screen-mobile-landscape) {
        padding: 0 15px 35px;

        .typo-custom-lead {
            .lead-first {
                font-size: 5.0rem;
            }

            .lead-second {
                font-size: 4.0rem;

                & + div {
                    clear: both;
                    padding: 15px 0 0;
                }
            }
        }

        .typo-custom-coupon {
            text-align: center;
            
            &.flex {
                display: block;
            }

            [class^="float-"] {
                text-align: center;
                float: none;
                margin-left: 0;
                margin-right: 0;
                margin-top: 15px;
            }
        }
    }

    @media (max-width: 500px) {
        .typo-custom-lead {
            text-align: center;
            padding: 32px 0 0;

            .badge {
                float: none;
                margin-right: 0;
                margin-bottom: 30px;
            }
        }
    }

    @media (max-width: $screen-mobile-medium) {
        .typo--wrapped {
            padding: 0 0;
        }
    }
}
</style>
